/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ProviderRecord } from './ProviderRecord';

/**
 * Class that define the request payload for MOMO
 */
export type PayOnlyOperationReqMomoDTO = {
    /**
     * Amount to pay
     */
    amount: number;
    /**
     * Currency of the operation
     */
    currency: PayOnlyOperationReqMomoDTO.currency;
    /**
     * Description given by the merchant about the payment collection
     */
    description?: string;
    provider: ProviderRecord;
};

export namespace PayOnlyOperationReqMomoDTO {

    /**
     * Currency of the operation
     */
    export enum currency {
        GHS = 'GHS',
        NGN = 'NGN',
    }


}
